import { asyncLoad } from '@util'

export default {
  path: 'sell',
  component: asyncLoad(() => import('@components/LocalMerchant/VR/Sell'))
}
